import { firebaseService } from '../config/firebase';
import { authService } from './authService';
import { ChatFeedback, FeedbackType, NegativeFeedbackReason } from '@/types/feedback';
import { apiService } from './apiService';

class FeedbackService {
  private readonly COLLECTION_NAME = 'chat_feedback';

  async submitFeedback(
    chatId: string,
    feedbackType: FeedbackType,
    textFeedback: string,
    selectedReasons?: NegativeFeedbackReason[]
  ): Promise<ChatFeedback> {
    const user = authService.getCurrentUser();
    if (!user) {
      throw new Error('User must be authenticated to submit feedback');
    }

    try {
      const feedbackId = `${chatId}_${user.uid}_${Date.now()}`;
      const feedback: ChatFeedback = {
        id: feedbackId,
        chatId,
        userId: user.uid,
        feedbackType,
        textFeedback,
        createdAt: Date.now()
      };

      // Only add selectedReasons if it's negative feedback and has values
      if (feedbackType === 'negative' && selectedReasons && selectedReasons.length > 0) {
        feedback.selectedReasons = selectedReasons;
      }
      
      await firebaseService.saveDocument(this.COLLECTION_NAME, feedback.id, feedback);
      return feedback;
    } catch (error) {
      apiService.handleError(error as Error | Response);
      throw error;
    }
  }

}

export const feedbackService = new FeedbackService();
